// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Category = React.forwardRef(function Category(props, ref) {
    return <SvgIcon {...props} ref={ref}><><path d="m12 2-5.5 9h11z"/><circle cx="17.5" cy="17.5" r="4.5"/><path d="M3 13.5h8v8H3z"/></></SvgIcon>;
});
export default Category;
